export default {
    unit_type_id: "Id",
    unit_type_name: "Nombre",
    unit_type_status: "Estado",
    unit_type_add_new: "Agregar Nuevo",
    unit_type_events: "Eventos",
    unit_type_uses_sim: "Usa SIM",
    unit_type_use_imei_as_serial: "Usar IMEI como Número de Serial",
}